import { Link } from "react-router-dom";

import { UserProfileInterface } from "@interfaces/index";
import { Button, AlertCircleSvg, ChevronRightSvg } from "@components/index";

export const DesktopProfile = ({
  userInfo,
  onVerifyEmail,
}: {
  userInfo: UserProfileInterface;
  onVerifyEmail: () => void;
}) => (
  <div className="max-w-[924px] px-10 pt-8">
    <div className="py-4 text-400 font-bold">Personal details</div>
    {!userInfo.emailVerified && (
      <div className="my-4 flex items-center justify-between gap-x-4 rounded-lg bg-black-8 px-4 py-2">
        <div className="text-200 md:text-300">
          Your Email is not verified, please verify you Email.
        </div>
        <Button height="small" title="Verify" onClick={onVerifyEmail} />
      </div>
    )}
    <Link
      to="/profile/change-name"
      className="flex h-[71px] items-center justify-between text-300"
    >
      <div className="flex">
        <div className="w-60 text-black-70">Name</div>
        <div className="w-60">{userInfo.fullName}</div>
      </div>
      <div className="text-black-54">
        <ChevronRightSvg />
      </div>
    </Link>
    <div className="h-px bg-black-16" />
    <Link
      to="/profile/change-password"
      className="flex h-[71px] items-center justify-between text-300"
    >
      <div className="flex">
        <div className="w-60 text-black-70">Password</div>
        <div className="w-60">••••••••••••</div>
      </div>
      <div className="text-black-54">
        <ChevronRightSvg />
      </div>
    </Link>
    <div className="h-px bg-black-16" />
    <div className="flex h-[71px] items-center text-300">
      <div className="w-60 text-black-70">Client code</div>
      <div className="w-60 text-black-54">{userInfo.clientCode}</div>
    </div>
    <div className="pb-5 pt-8 text-400 font-bold">Contact Info</div>
    <div className="flex h-[71px] items-center justify-between text-300">
      <div className="flex">
        <div className="w-60 text-black-70">Email</div>
        <div className="w-60 text-black-54">{userInfo.email}</div>
      </div>
      <div className="flex items-center gap-x-6 text-right text-100 text-black-54">
        <div className="hidden lg:block">
          The address used to identify your account.
          <br />
          You can't change this address.
        </div>
        <div
          className="shrink-0"
          title="The address used to identify your account. You can't change this address."
        >
          <AlertCircleSvg />
        </div>
      </div>
    </div>
    <div className="h-px bg-black-16" />
    <Link
      to="/profile/change-phone"
      className="flex h-[71px] items-center justify-between text-300"
    >
      <div className="flex">
        <div className="w-60 text-black-70">Phone</div>
        <div className="w-60">{userInfo.phone}</div>
      </div>
      <div className="text-black-54">
        <ChevronRightSvg />
      </div>
    </Link>
  </div>
);
